/**
 * @typedef  CheckBoxOrRadioOption
 * @property {string} id
 * @property {string} label
 * @property {string} value
 * @property {boolean} checked
 * @property {boolean} disabled
 * @property {number} total
 * @property {CheckBoxOrRadioOption[]} [subOptions]
 */

/**
 * @typedef  Filter
 * @property {string} id
 * @property {string} type
 * @property {string} label
 * @property {CheckBoxOrRadioOption[]} options
 */

/**
 * @typedef  Pagination
 * @property {number} rowsCount
 * @property {number} rowsOnPage
 * @property {number} pagesCount
 * @property {number} currentPage
 */

/**
 * @typedef  Product
 * @property {string} id
 * @property {string} name
 * @property {string} group
 * @property {string} description
 * @property {{string}} url
 */

/**
 * @typedef State
 * @type {Object}
 * @property {Filter[]} filters
 * @property {Array} items
 * @property {string} searchValue
 * @property {Pagination} pagination
 * @property {boolean} isLoading
 * @property {boolean} isLoadingMore
 */

exports.unused = {};
